import React from 'react';
import { Logo } from '~/source/ui/logo/logo';
import { Selector } from '~/source/ui/selector/selector';
import { SplashLayout } from '~/source/ui/splash-layout/splash-layout';
import type { Agreements as Props } from './agreements.page.types';

export const Agreements: React.FC<Props> = ({ selector }) => (
  <SplashLayout>
    <div className="agreements">
      <Logo elementName="h1" variant="light" />
      <Selector {...selector} />
    </div>
  </SplashLayout>
);
